import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { noop } from 'rxjs';
import { SaveTemplateModel } from './save-template.types';
import { slideInOutHeight } from 'app/shared/functions/animation.functions';

@Component({
  selector: 'app-save-template',
  templateUrl: './save-template.component.html',
  styleUrls: ['./save-template.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatOptionModule,
    MatInputModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideInOutHeight],
})
export class SaveTemplateComponent {
  form = new FormGroup({ saveMode: new FormControl('update'), templateName: new FormControl('') });

  get isCreateSaveMode(): boolean {
    return this.saveModeControl.value === 'create';
  }

  private get saveModeControl(): AbstractControl {
    return this.form.get('saveMode');
  }

  private get templateNameControl(): AbstractControl {
    return this.form.get('templateName');
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SaveTemplateModel,
    private readonly matDialogRef: MatDialogRef<SaveTemplateComponent>,
  ) {
    this.saveModeControl.valueChanges.subscribe((value) =>
      value === 'update' ? this.templateNameControl.setValue('') : noop(),
    );
  }

  save(): void {
    this.matDialogRef.close(this.form.getRawValue());
  }
}
